import {setupPrototypes} from './prototypes.js'
import {setupHelpers} from './helpers.js'
import {setupState} from './state.js'
import {registerServiceWorkers} from './serviceworker.js'
import {setupOnlineStatus} from './onlinestatus.js'
import {lockOrientation} from './orientation.js'
//import { forceWindowSize } from './windowsize.js'
//import { screenCapture } from './screencapture.js'
//import { setupFileSaver } from './filesave.js'
import Vue from 'vue'
import Welcome from './Welcome.vue'

setupPrototypes()
setupHelpers()
setupState()
registerServiceWorkers()
setupOnlineStatus()
lockOrientation()
//setupFileSaver()

window.debugging = false

/* env */
window.welcome.api_server = process.env.VUE_APP_API_SERVER
window.user_portal_url = process.env.VUE_APP_USER_PORTAL_URL
window.logo_image_path = process.env.VUE_APP_LOGO_IMAGE_PATH

window.resizeTo(320, 600)
//window.screenCapture = screenCapture


window.welcome.app = new Vue({
	render: h => h(Welcome)
}).$mount('#welcome')